import { render, staticRenderFns } from "./HongKongIndustryPanel.vue?vue&type=template&id=20a79acf&scoped=true"
import script from "./HongKongIndustryPanel.vue?vue&type=script&lang=js"
export * from "./HongKongIndustryPanel.vue?vue&type=script&lang=js"
import style0 from "./HongKongIndustryPanel.vue?vue&type=style&index=0&id=20a79acf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a79acf",
  null
  
)

export default component.exports